import { AddDamagedPointQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addDamagedPoint/addDamagedPointQuery.type';
import { addDamagedPointFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addDamagedPoint/addDamagedPointQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const useAddDamagedPointQueryOptions = (params?: {
  onSuccess?: () => void;
}) => {
  return useMutation({
    mutationKey: ['addDamagedPoint'],
    mutationFn: (params: AddDamagedPointQueryParamsType) =>
      addDamagedPointFunction(params),
    onSuccess: params?.onSuccess,
  });
};
